/**
 * 연동(동일값) 셀 표식 — 셀 우상단 모서리의 직각 삼각형(dog-ear).
 *
 * 같은 metadata identity 를 가진 셀이 다른 위치에도 존재해(=클릭 시 "숫자가 연동되는
 * 셀들" linkage popover/modal 이 열리는) 셀임을 시각적으로 알린다. 정보 표시 전용이며
 * 클릭은 통과시킨다(pointer-events-none). 부모 셀(`<td>`)이 `position: relative` 임을
 * 전제로 absolute 로 우상단에 고정한다.
 *
 * 직각이 셀의 우상단 모서리에 놓이고, 두 직각변은 셀의 위/오른쪽 테두리를 따르며,
 * 빗변이 셀 안쪽을 향해 잘려 들어간다.
 */
const MARKER_SIZE = 9; // 직각변 길이(px)

const CellLinkageMarker = () => (
  <svg
    width={MARKER_SIZE}
    height={MARKER_SIZE}
    viewBox={`0 0 ${MARKER_SIZE} ${MARKER_SIZE}`}
    className="pointer-events-none absolute right-0 top-0 z-[2] fill-status-positive"
    data-linkage-marker
    aria-hidden
  >
    <title>숫자가 연동되는 셀입니다.</title>
    {/* (0,0) 좌상단 → (size,0) 우상단(직각) → (size,size) 우하단, 빗변이 안쪽을 향함 */}
    <polygon points={`0,0 ${MARKER_SIZE},0 ${MARKER_SIZE},${MARKER_SIZE}`} />
  </svg>
);

export default CellLinkageMarker;
